export default __webpack_public_path__ + "images/T7.382ab4f.png";